import { Container, Grid } from '@mui/material';
import AppContainer from 'src/components/appComponents/AppContainer';
import AppLoadingAndErrorWrapper from 'src/components/appComponents/AppLoadingAndErrorWrapper';
import ChannelAiSuggestionsInfo from 'src/sections/channelAiSuggestions/ChannelAiSuggestionsInfo';
import { useGeChannelAiSuggestionByIdQuery } from 'src/graphql';
import { useParams } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';
import { useSettingsContext } from 'src/components/settings';
import ChannelAiSuggestionsButtons from 'src/sections/channelAiSuggestions/ChannelAiSuggestionsButtons';

export default function ChannelAiSuggestionsDetailsPage() {
  const settings = useSettingsContext();
  const { suggestedVideoId } = useParams();

  const { data: suggestionVideo, isLoading: isLoadingGetSuggestionVideo } =
    useGeChannelAiSuggestionByIdQuery({ id: suggestedVideoId });

  return (
    <>
      <AppLoadingAndErrorWrapper isLoading={isLoadingGetSuggestionVideo}>
        {/* Video Info */}
        <AppContainer
          pageTitle="View"
          routeLinks={[
            { name: 'ChannelAi Suggestions' },
            { name: 'Suggestions', href: `${paths.dashboard.channelAiSuggestions.suggestions}` },
            {
              name: 'View',
            },
          ]}
        >
          <Grid container spacing={2}>
            <ChannelAiSuggestionsInfo suggestionVideo={suggestionVideo?.file_suggestions_by_pk} />
          </Grid>
        </AppContainer>

        {/* Buttons */}
        <Container maxWidth={settings.themeStretch ? false : 'xl'}>
          <ChannelAiSuggestionsButtons suggestionVideo={suggestionVideo?.file_suggestions_by_pk} />
        </Container>
      </AppLoadingAndErrorWrapper>
    </>
  );
}
